/**
 * Надійне копіювання тексту в буфер обміну з fallback'ом.
 * Повертає true/false в залежності від успіху.
 *
 * Обмеження:
 * - navigator.clipboard працює тільки в secure context (https/localhost)
 * - document.execCommand('copy') потрібен як fallback для старих браузерів / iOS
 */
export async function copyToClipboard(text) {
    // 1) Спроба через сучасний Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            // наприклад, відмова в permission або системна помилка
            console.warn('[Copy to clipboard] navigator.clipboard.writeText failed:', err);
        }
    }

    // 2) Fallback через тимчасовий <textarea> + execCommand('copy')
    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;

        // Мінімізація "мігання" та впливу на layout
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        textArea.style.top = '0';

        document.body.appendChild(textArea);

        // iOS має свої заморочки з selection
        const isIOS = /ipad|iphone|ipod/i.test(navigator.userAgent);

        if (isIOS) {
            const range = document.createRange();
            range.selectNodeContents(textArea);

            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            textArea.setSelectionRange(0, 999999); // "на всякий"
        } else {
            textArea.select();
        }

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (!successful) {
            console.warn('[Copy to clipboard] document.execCommand("copy") returned false');
        }

        return successful;
    } catch (err) {
        console.error('[Copy to clipboard] fallback copy failed:', err);
        return false;
    }
}
